<div class="super-navbar">
  <a class="hide-text" [href]="'mailto:' + contact.email">
    <i class="fa-solid fa-envelope"></i> {{ contact.email }}
  </a>
  <span class="spacer hide-text">|</span>
  <a class="hide-text" [href]="'tel:' + contact.phone">
    <i class="fa-solid fa-phone"></i> {{ contact.phone }}
  </a>
  <span class="example-spacer text-center hide-text">
    <button class="header-video-btn" (click)="onShowVideo()">
      <span class="material-icons-outlined"> play_arrow </span>
      <span class="header-video-btn--txt">Watch a video guide...</span>
    </button>
  </span>
  <button
    mat-button
    [matMenuTriggerFor]="currencyMenu"
    *ngIf="user.isLoggedIn && selectedCurrency.code !== undefined"
  >
    <img
      [src]="'assets/' + selectedCurrency.flagPath"
      [alt]="selectedCurrency.name"
    />
    {{ selectedCurrency.code }}
    <mat-icon class="icon-arrow-profile filter-mat-icon"
      >keyboard_arrow_down</mat-icon
    >
  </button>
  <span
    class="spacer"
    *ngIf="
      user.isLoggedIn &&
      user.accountTypeCode === accountType.BUYER_PORTAL &&
      userDetailsService.checkPermissions(
        permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
      )
    "
    >|</span
  >
  <button
    mat-button
    routerLinkActive="mat-active"
    *ngIf="
      user.isLoggedIn &&
      user.accountTypeCode === accountType.BUYER_PORTAL &&
      userDetailsService.checkPermissions(
        permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
      )
    "
    routerLink="/client/client-details/company-information/{{ user.accountId }}"
  >
    <mat-icon>settings</mat-icon>
    Account Configuration
  </button>
</div>
<mat-menu #currencyMenu="matMenu" class="currency">
  <button
    mat-menu-item
    *ngFor="let currency of currencies"
    (click)="onSelectCurrency(currency)"
    [class.mat-active-currency]="currencyActivation(currency)"
  >
    <img [src]="'assets/' + currency.flagPath" [alt]="currency.name" />
    {{ currency.code }}
  </button>
</mat-menu>
